module.exports = __webpack_public_path__ + "img/2.5346d7c3.jpg";